import type { ReferenceArticle } from "../../_shared/reference-articles/types";

export const REFERENCE_ARTICLES: ReferenceArticle[] = [
	{
		title: "TL-リンカーンと連携する方法",
		thumbnailUrl: "/assets/site-controller/reference-articles/tl-lincoln/settings.jpg",
		url: "https://chillnn.notion.site/TL-25cfffe15c578091bd97f754102ba062",
	},
];
